module.exports = __webpack_public_path__ + "img/catalog-active.c309d7ac.svg";